/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * プロダクト検索情報
 */
export interface Szoa109aRequestPrdSearchInfo { 
    /**
     * 中継店内部お客さま番号：数字<br>　直販の場合、内部お客さま番号の上限桁数分、「9]を設定
     */
    rlyisdVisitNo: string;
    /**
     * サービス種別コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C008410」のユーザコードを設定
     */
    srvClsfyCode?: string;
    /**
     * プロダクト種別区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C011300」のユーザコードを設定
     */
    prdClsfyDiv?: string;
    /**
     * プロダクトコード：英数字
     */
    prdCode?: string;
    /**
     * カスタマイズ検索条件エリア
     */
    additionalCondition?: object | null;
}

